/**
 * LP unique selling points carousel (sections/medispa-lp-unique-selling-points.liquid).
 * Loaded by deferred-scripts.liquid (marker: unique-selling-points-slider).
 */
import { medispaCarousels, whenSwiperReady } from '@/components/utils/medispa-lp';

whenSwiperReady(() => {
  const slider = document.querySelector<HTMLElement>('.unique-selling-points-slider.swiper');
  if (!slider) return;

  medispaCarousels()['unique-selling-points'] = new window.Swiper(slider, {
    enabled: true,
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    pagination: {
      el: '.unique-selling-points-slider .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3.5,
        slidesPerGroup: 3,
      },
      1139: {
        slidesPerView: 'auto',
      },
    },
  });
});
